/* eslint-disable import/no-anonymous-default-export */
import { ADD_TICKET, REMOVE_TICKET, EMPTY_CART, SET_TICKET_TO_ZERO } from "../actionTypes/cart";

const initialState = JSON.parse(localStorage.getItem("Cart")) || {
  list: [],
  totalTickets: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_TICKET: {
      const { ticket } = action;
      const list = state.list;
      const isTicketExist = list.some((item) => item.code === ticket.code);
      if (list.length === 0 || !isTicketExist) {
        list.push({ ...ticket, number: 1 });
        const cart = { list, totalTickets: calcTotalTickets(list) };
        saveToLocalStorage(cart);
        return cart;
      } else {
        const newList = list.map((item) =>
          item.code === ticket.code
            ? { ...item, number: item.number + 1 }
            : item
        );
        const cart = { list: newList, totalTickets: calcTotalTickets(newList) };
        saveToLocalStorage(cart);
        return cart;
      }
    }

    case REMOVE_TICKET: {
      const { ticketCode } = action;
      const newList = [];
      state.list.map((item) => {
        if (item.code === ticketCode) {
          if (item.number > 1)
            newList.push({ ...item, number: item.number - 1 });
        } else newList.push(item);
      });
      const cart = { list: newList, totalTickets: calcTotalTickets(newList) };
      saveToLocalStorage(cart);
      return cart;
    }

    case SET_TICKET_TO_ZERO: { 
      const { ticketCode } = action;
      const newList = state.list.filter((item) => item.code !== ticketCode);
      const cart = { list: newList, totalTickets: calcTotalTickets(newList) };
      saveToLocalStorage(cart);
      return cart;
    }

    case EMPTY_CART: {
      const cart = { list: [], totalTickets: 0 };
      saveToLocalStorage(cart);
      return cart;
    }

    default:
      return state;
  }
}

const calcTotalTickets = (list) => {
  let total = 0;
  list.map((i) => (total += i.number));
  return total;
};

const saveToLocalStorage = (data) => {
  localStorage.setItem("Cart", JSON.stringify(data));
};
